export enum AppLocation {
  // --- authedBackgroundAppRoute
  Home = 'Home',
  VirtualCardDetail = 'VirtualCardDetail',
  VirtualCards = 'VirtualCards',
  VirtualCardsAll = 'VirtualCardsAll',
  VirtualCardsNeedsApproval = 'VirtualCardsNeedsApproval',
  ManagerReviewReimbursements = 'ManagerReviewReimbursements',
  ManagerReviewTransactions = 'ManagerReviewTransactions',
  ManagerReviewReimbursemets = 'ManagerReviewReimbursements',
  ManagerReviewReimbursementDetail = 'ManagerReviewReimbursementDetail',
  MyWalletReimbursements = 'MyWalletReimbursemens',
  MyWalletReimbursementDetail = 'MyWalletReimbursementDetail',
  MyWalletVirtualCardDetail = 'MyWalletVirtualCardDetail',
  MyWalletVirtualCards = 'MyWalletVirtualCards',
  MyWalletPhysicalCards = 'MyWalletPhysicalCards',
  MyWalletBudgets = 'MyWalletBudgets',
  MyWalletBudgetsPending = 'MyWalletBudgetsPending',
  MyWalletTransactions = 'MyWalletTransactions',
  AccountingExpenseReports = 'AccountingExpenseReports',
  AccountingReviewReports = 'AccountingReviewReports',
  AccountingReimbursements = 'AccountingReimbursements',
  CardTransactions = 'CardTransactions',
  Cards = 'Cards',
  PhysicalCards = 'PhysicalCards',
  Account = 'Account',
  AccountOverview = 'AccountOverview',
  AccountBudgets = 'AccountBudgets',
  AccountVirtualCards = 'AccountVirtualCards',
  AccountTransactions = 'AccountTransactions',
  AccountBudgetHistory = 'AccountBudgetHistory',
  AccountSettings = 'AccountSettings',
  Accounts = 'Accounts',
  Budgets = 'Budgets',
  BudgetsAll = 'BudgetsAll',
  BudgetsNeedsApproval = 'BudgetsNeedsApproval',
  BudgetDetail = 'BudgetDetail',
  BudgetOverview = 'BudgetOverview',
  BudgetVirtualCards = 'BudgetVirtualCards',
  BudgetTransactions = 'BudgetTransactions',
  BudgetHistory = 'BudgetHistory',
  Activity = 'Activity',
  Insights = 'Insights',
  StreamingAgent = 'StreamingAgent',
  Profile = 'Profile',
  ProfileOverview = 'ProfileOverview',
  ProfileInfo = 'ProfileInfo',
  ProfileNotifications = 'ProfileNotifications',
  ProfileSecurity = 'ProfileSecurity',
  ProfileDelete = 'ProfileDelete',
  ProfileApiKeys = 'ProfileApiKeys',
  Transactions = 'Transactions',
  People = 'People',
  PeopleMembers = 'PeopleMembers',
  PeopleInvitedToOrg = 'PeopleInvitedToOrg',
  PeopleCancelOrgInvite = 'PeopleCancelOrgInvite',
  Expenses = 'Expenses',
  BillPayDetail = 'BillPayDetail',
  BillPay = 'BillPay',
  BillPayAll = 'BillPayAll',
  ExpenseReport = 'ExpenseReport',
  OrganizationSettings = 'OrganizationSettings',
  OrganizationSettingsExpenseCategories = 'OrganizationSettingsExpenseCategories',
  OrganizationSettingsExpenseCategoryLabels = 'OrganizationSettingsExpenseCategoryLabels',
  OrganizationSettingAutomationSettings = 'OrganizationSettingAutomationSettings',
  OrganizationSettingsAutomationRules = 'OrganizationSettingsAutomationRules',
  OrganizationSettingsReportCycle = 'OrganizationSettingsReportCycle',
  OrganizationSettingsReceiptRules = 'OrganizationSettingsReceiptRules',
  OrganizationSettingsExpenseRequirements = 'OrganizationSettingsExpenseRequirements',
  OrganizationSettingsExpenseRequirementsReceiptRules = 'OrganizationSettingsExpenseRequirementsReceiptRules',
  OrganizationSettingsExpenseRequirementsAdditionalFields = 'OrganizationSettingsExpenseRequirementsAdditionalFields',
  OrganizationSettingsDepartments = 'OrganizationSettingsDepartments',
  OrganizationSettingsIntegrations = 'OrganizationSettingsIntegrations',
  OrganizationSettingsManageSubscription = 'OrganizationSettingsManageSubscription',
  OrganizationSettingsExpenseSettings = 'OrganizationSettingsExpenseSettings',
  OrganizationSettingsBusinessRules = 'OrganizationSettingsBusinessRules',
  OrganizationSettingsOrganizationInfo = 'OrganizationSettingsOrganizationInfo',
  OrganizationSettingsAPIKeys = 'OrganizationSettingsApiKeys',
  OrganizationSettingsApprovers = 'OrganizationSettingsApprovers',
  OrganizationSettingsReimbursements = 'OrganizationSettingsReimbursements',
  OrganizationSettingsSSO = 'OrganizationSettingsSSO',
  Onboarding = 'Onboarding',
  OrgInviteDecision = 'OrgInviteDecision',
  OrgExpenseReportsHistoricalReports = 'OrgExpenseReportsHistoricalReports',
  OrgExpenseReport = 'OrgExpenseReport',
  DepartmentDetails = 'DepartmentDetails',
  Downloads = 'Downloads',
  CancelSubscription = 'CancelSubscription',

  // --- authedPopupAppRoute
  ScreenVirtualCard = 'ScreenVirtualCard',
  DeactivateVirtualCard = 'DeactivateVirtualCard',
  DeactivateBillPayCard = 'DeactivateBillPayCard',
  DeactivateBudget = 'DeactivateBudget',
  RegisterAccount = 'RegisterAccount',
  UpdateProfilePhoto = 'UpdateProfilePhoto',
  UpgradeSubscription = 'UpgradeSubscription',
  UserScreeningInfo = 'UserScreeningInfo',
  ActionUnavailable = 'ActionUnavailable',
  DownloadTransactions = 'DownloadTransactions',
  RegisterOrganization = 'RegisterOrganization',
  ManageOrgInvite = 'ManageOrgInvite',
  ManageOrgIntegration = 'ManageOrgIntegration',
  RemoveUserFromOrganization = 'RemoveUserFromOrganization',
  ChangePassword = 'ChangePassword',
  ManageTrustedDevices = 'ManageTrustedDevices',
  CloseVirtualCard = 'CloseVirtualCard',
  CloseBillPayCard = 'CloseBillPayCard',
  CloseAccount = 'CloseAccount',
  SetOrgExpenseReportCycle = 'SetOrgExpenseReportCycle',
  ShareBillPayVirtualCard = 'ShareBillPayVirtualCard',

  // --- authedLeftFlyoutAppRoute
  Notifications = 'Notifications',
  Help = 'Help',
  Search = 'Search',
  CspUserDetail = 'CspUserDetail',

  // --- authedRightFlyoutAppRoute
  CreateVirtualCard = 'CreateVirtualCard',
  RequestVirtualCard = 'RequestVirtualCard',
  UpdateVirtualCard = 'UpdateVirtualCard',
  CreateBudget = 'CreateBudget',
  RequestBudget = 'RequestBudget',
  UpdateBudget = 'UpdateBudget',
  UpdateBudgetRequest = 'UpdateBudgetRequest',
  TransactionDetail = 'TransactionDetail',
  PeopleMembersDetail = 'PeopleMembersDetail',
  PeopleInvitedToOrgDetail = 'PeopleInvitedToOrgDetail',
  InvitePeople = 'InvitePeople',
  AddExpense = 'AddExpense',
  UpdateExpense = 'UpdateExpense',
  UpdateBulkTransactions = 'UpdateBulkTransactions',
  CreateBillPay = 'CreateBillPay',
  UpdateBillPayVirtualCard = 'UpdateBillPayVirtualCard',
  CreateAutomationRule = 'CreateAutomationRule',
  UpdateAutomationRule = 'UpdateAutomationRule',
  BulkUploadExpenseLabels = 'BulkUploadExpenseLabels',

  // --- unauthedAppRoute
  Signin = 'Signin',
  Signup = 'Signup',
  ResetPassword = 'ResetPassword',
  CspSignin = 'CspSignin',
  Privacy = 'Privacy',
  Terms = 'Terms',
  Support = 'Support',
  SsoCallback = 'SsoCallback',
}

export enum SidenavContentType {
  Main = 'Main',
  Settings = 'Settings',
}
